import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { truncateString } from "../../shared/sharedFunctions";
import MaterialTable from "material-table";
import { defaultTableOptions, tableIcons, textCell, textHeader } from "../../shared/tableHelper";

const BreachTable = (props) => {
	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			{(props.breaches && props.breaches.length > 0)?
				<MaterialTable
					icons={tableIcons}
					columns={[
						{
							title: "Email Address",
							field: "email",
							cellStyle: textCell,
							headerStyle: textHeader
						},
						{
							title: "Password",
							field: "",
							cellStyle: textCell,
							headerStyle: textHeader,
							render: (breach, index) => {
								return (breach.password)? breach.password.split(",").map((password, passIndex) => {
									return (
										<Stack direction="column" key={`breach_${index}_pass_${passIndex}`}>
											<Typography>
												{truncateString(password, 30)}
											</Typography>
										</Stack>
									)
								})
								:
								<Typography>{`[unavailable]`}</Typography>
							}
						},
						{
							title: "Breach",
							field: "name",
							cellStyle: textCell,
							headerStyle: textHeader,
						},
						{
							title: "Date",
							field: "breach_date",
							cellStyle: textCell,
							headerStyle: textHeader,
							render: (breach) => {
								return <Typography>{breach.breach_date.toLocaleDateString("en-GB")}</Typography>
							}
						},
						{
							title: "Compromised Data",
							field: "compromised_data",
							cellStyle: textCell,
							headerStyle: textHeader
						}
					]}
					data={props.breaches}
					title=""
					options={defaultTableOptions}
				/>
			: <MaterialTable icons={tableIcons} title="" options={defaultTableOptions}/>}		
		</Box>
	);
}

export default BreachTable;